export class ResponseStatus{
    constructor(){
        this.status ="";
    }
    status: string;
}